<template>
  <div class="select-location">
    <MainNav />
    <div class="container-fluid px-0">
      <div class="row no-gutters" style="border-top: 1px solid #F4F4F4;">
        <div class="col-md-8">
          <div class="map-container">
            <googlemaps-map
              ref="map"
              class="map"
              :center.sync="center"
              :zoom.sync="zoom"
              :options="options"
              @dblclick="dblClick"
            >
              <!-- User Position -->
              <googlemaps-user-position
                v-if="userPosition"
                :position="userPosition"
              />

              <!-- Marker -->
              <googlemaps-marker
                title="Location"
                :draggable="true"
                :position="this.markerPosition"
                @dragend="this.setMarkerPosition"
                @drag="this.hideCircle"
                icon="/img/map-marker.png"
              />

              <!-- Circle -->
              <googlemaps-circle
                ref="circle"
                :center="markerPosition"
                :visible="showCircle"
                :radius="radius"
                :options="circleOptions"
              />
            </googlemaps-map>
          </div>
        </div>
        <div class="col">
          <div v-show="stepToShow === 1" id="step-1" class="h-100">
            <div
              class="p-5 text-center h-100 d-flex flex-column align-items-center justify-content-center"
            >
              <img
                src="/img/select-location.png"
                alt="Map marker icon"
                style="width: 73px; height: 73px;"
              />
              <h2 class="mt-4 mb-3">Select location</h2>
              <p>Double click on a location on the map to start!</p>
            </div>
          </div>
          <div v-show="stepToShow === 2" id="step-2" class="h-100">
            <div
              class="text-center h-100 d-flex flex-column align-items-center justify-content-center"
            >
              <div class="py-3">
                <h2>Select Radius</h2>
                <p>Select the radius distance for your search</p>
              </div>

              <div class="bg-light w-100" v-if="reports.length">
                <ul class="list-group p-3 w-100">
                  <li
                    v-for="report in reports"
                    v-bind:key="report.ReportTypeId"
                    class="list-group-item my-1 p-3"
                    v-bind:class="{
                      'list-group-item__selected':
                        selectedReportType.ReportTypeId === report.ReportTypeId
                    }"
                    @click="selectReportType(report)"
                  >
                    <div
                      class="list-group-item__content d-flex justify-content-between align-items-center"
                    >
                      <div class="check">&#10004;</div>
                      <div>
                        <h5 class="m-0">{{ report.SearchRadius }} Kilometre</h5>
                        <p class="h5">{{ report.Name }}</p>
                        <p class="m-0">{{ report.Description }}</p>
                      </div>
                      <p class="m-0 price text-primary">
                        <span v-show="showPrices"
                          >£{{ report.ListPrice.toFixed(2) }}</span
                        >
                      </p>
                    </div>
                  </li>
                </ul>
              </div>

              <div class="d-flex justify-content-center" v-else>
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Loading report types...</span>
                </div>
              </div>

              <div class="w-100 p-3">
                <form novalidate @submit="checkForm">
                  <div class="form-group pt-2">
                    <input
                      type="text"
                      class="form-control"
                      id="project-name"
                      placeholder="Project Name e.g. 'ERCCIS Data Search Study'"
                      required
                      v-model="projectName"
                    />
                    <div class="invalid-feedback">
                      Please choose a project name.
                    </div>
                  </div>

                  <div class="form-group pt-2">
                    <input
                      type="text"
                      class="form-control"
                      id="project-code"
                      placeholder="Project Code e.g. 'ERCCIS_026_Allet'"
                      required
                      v-model="projectCode"
                    />
                    <div class="invalid-feedback">
                      Please provide a project code.
                    </div>
                  </div>

                  <div class="form-group pt-2" v-if="userType == 2">
                    <input
                      type="text"
                      class="form-control"
                      id="purchase-order"
                      placeholder="Purchase Order Number, if required"
                      v-model="purcahseOrderNumber"
                    />
                  </div>

                  <div
                    class="card-container py-4"
                    v-show="takePayment == 'true'"
                  >
                    <h3>Payment Details</h3>
                    <div id="card" ref="card"></div>
                  </div>

                  <div class="form-group form-check pt-2 pb-4">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      id="exampleCheck1"
                      v-model="termsAccepted"
                    />
                    <label
                      class="form-check-label text-primary"
                      for="exampleCheck1"
                      >Accept the
                      <router-link
                        class="text-underline"
                        :to="{ name: 'terms-and-conditions' }"
                        target="_blank"
                        >Terms and Conditions</router-link
                      ></label
                    >
                  </div>

                  <div v-if="formErrors.length">
                    <div
                      class="alert alert-danger alert-dismissible fade show"
                      role="alert"
                      v-for="error in formErrors"
                      :key="error"
                    >
                      {{ error }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                  <div
                    v-if="createReportSuccess"
                    class="alert alert-success alert-dismissible fade show"
                    role="alert"
                  >
                    Report created successfully! Your PDF report is being
                    processed and will be sent to your email within the next 30
                    minutes.
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>

                  <button
                    v-if="loading"
                    class="btn btn-primay btn-block mb-3"
                    disabled
                  >
                    Loading...
                  </button>
                  <button
                    v-else
                    type="submit"
                    class="btn btn-primary btn-block mb-3 p-4"
                    v-bind:class="{ disabled: this.termsAccepted === false }"
                    :disabled="this.termsAccepted === false"
                  >
                    Generate your report
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ConfirmSearchModal
      :reportType="selectedReportType"
      :position="markerPosition"
      :showPrice="showPrices"
      @agree="runSearch"
    />
    <Footer />
  </div>
</template>
<script>
import $ from "jquery";
import ConfirmSearchModal from "@/components/ConfirmSearchModal.vue";
import Footer from "@/components/Footer.vue";
import MainNav from "@/components/MainNav.vue";

let cardElement = null;
let stripe;

export default {
  name: "CreateReport",
  components: {
    ConfirmSearchModal,
    Footer,
    MainNav
  },

  data() {
    return {
      center: {
        lat: 50.681841,
        lng: -4.219628
      },
      options: {
        fullscreenControl: false,
        streetViewControl: false,
        disableDoubleClickZoom: true,
        draggableCursor: "pointer",
        restriction: {
          latLngBounds: {
            north: 51.0970679287734,
            south: 49.64929382258863,
            east: -4.090335319055839,
            west: -6.613173161887175
          },
          strictBounds: false
        }
      },
      userPosition: null,
      markerPosition: {},
      zoom: 10,
      showCircle: false,
      radius: 1000,
      selectedReportType: {},
      circleOptions: {
        strokeColor: "#929428",
        strokeWeight: 1,
        fillColor: "#ADAF36"
      },
      stepToShow: 1,
      termsAccepted: false,
      projectCode: null,
      projectName: null,
      purcahseOrderNumber: null,
      formErrors: [],
      createReportSuccess: false,
      stripeComplete: false,
      stripeOptions: {
        style: {
          base: {
            color: "#32325d",
            fontFamily: '"Heebo", sans-serif',
            fontSmoothing: "antialiased",
            "::placeholder": {
              color: "#aab7c4"
            }
          },
          invalid: {
            color: "#fa755a",
            iconColor: "#fa755a"
          }
        }
      }
    };
  },

  computed: {
    reports() {
      return this.$store.getters.reports;
    },
    loading() {
      return this.$store.state.loading;
    },
    email() {
      return localStorage.getItem("CWT_USER");
    },
    takePayment() {
      return localStorage.getItem("CWT_TAKE_PAYMENT");
    },
    // Trusted (invoiced) accounts are billed rather than charged online, but
    // they are still shown prices. Only SLA accounts are not. `takePayment`
    // decides whether to collect a card, `showPrices` decides display.
    showPrices() {
      return localStorage.getItem("CWT_SHOW_PRICES") !== "false";
    },
    stripeKey() {
      return process.env.VUE_APP_STRIPE_PUBLISHABLE;
    },
    userType() {
      return localStorage.getItem("CWT_ACCOUNT_TYPE") !== null
        ? localStorage.getItem("CWT_ACCOUNT_TYPE")
        : 0;
    }
  },

  mounted() {
    stripe = window.Stripe(process.env.VUE_APP_STRIPE_PUBLISHABLE);
    const elements = stripe.elements();

    // this.geolocate();
    this.$store.dispatch("getReportTypes").then(data => {
      //set default selected to 1km
      this.selectReportType(data[0]);
    });

    cardElement = elements.create("card");
    cardElement.mount("#card");
  },

  methods: {
    geolocate() {
      navigator.geolocation.getCurrentPosition(
        this.geolocateSuccess,
        this.geoLocateError
      );
    },
    geolocateSuccess(position) {
      let loc = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      };
      this.setUserPosition(loc);
      this.setMarkerPosition(loc);
    },
    geoLocateError(error) {
      this.setUserPosition(this.center);
    },
    setUserPosition(position) {
      this.center = position;
      this.userPosition = position;
      this.markerPosition = position;
    },
    setMarkerPosition(position) {
      this.showCircle = true;
      if (position) {
        let newPosition;

        if (position.latLng) {
          //gmaps position
          newPosition = {
            lat: position.latLng.lat(),
            lng: position.latLng.lng()
          };
        }

        if (position.lat && position.lng) {
          //geolocate position
          newPosition = position;
        }

        this.markerPosition = newPosition;
        this.stepToShow = 2;
      }
    },
    hideCircle() {
      this.showCircle = false;
    },
    selectReportType(reportType) {
      this.selectedReportType = reportType;
      this.radius = reportType.SearchRadius * 1000;
    },
    checkForm(e) {
      e.preventDefault();

      this.formErrors = [];
      this.createReportSuccess = false;

      let errorCount = 0;
      if (this.markerPosition == null) {
        this.formErrors.push("Please provide a location");
        errorCount++;
      }

      if (this.projectName == null || this.projectName.length === 0) {
        this.formErrors.push("Please provide a project name");
        errorCount++;
      }

      if (this.projectCode == null || this.projectCode.length === 0) {
        this.formErrors.push("Please provide a project code");
        errorCount++;
      }

      // `selectedReportType` starts as `{}` and is only populated once
      // `getReportTypes` resolves, so check for a report type id rather than
      // for undefined
      if (
        this.selectedReportType == null ||
        this.selectedReportType.ReportTypeId === undefined
      ) {
        this.formErrors.push("Please select a report type");
        errorCount++;
      }

      // Nothing is charged and no report is created until the client agrees
      // to the search parameters in the confirmation modal
      if (errorCount === 0) {
        $("#confirm-search-modal").modal("show");
      }
    },
    async runSearch() {
      this.$store.commit("SET_LOADING", true);

      if (localStorage.getItem("CWT_TAKE_PAYMENT") == "true") {
        const { paymentMethod, error } = await stripe.createPaymentMethod(
          "card",
          cardElement,
          {
            billing_details: { email: this.email }
          }
        );

        if (error) {
          // Show error in payment form
          this.formErrors.push(error.message);
          this.$store.commit("SET_LOADING", false);
        } else {
          // Send paymentMethod.id to your server (see Step 2)
          this.$users
            .confirmPayment({
              PaymentMethodId: paymentMethod.id,
              ReportType: this.selectedReportType
            })
            .then(response => {
              // Handle server response (see Step 3)
              this.handleServerResponse(response);
            });
        }
      } else {
        this.submit();
      }
    },
    async handleServerResponse(response) {
      if (response.status == 400 && response.errors) {
        // Show error from server on payment form
        this.formErrors = this.formErrors.concat(response.errors);
      } else if (response.data.requires_action) {
        const that = this; // :|

        // Use Stripe.js to handle the required card action
        stripe
          .confirmCardPayment(response.data.payment_intent_client_secret, {
            payment_method: {
              card: cardElement,
              billing_details: { email: this.email }
            }
          })
          .then(function(result) {
            // Handle result.error or result.paymentIntent
            if (result.error) {
              that.formErrors.push(result.error.message);
            } else {
              // payment intent is confirmed already here so no need to send back up to server
              // need to manually create the `ReportPayment` to submit the report to the server
              const reportPayment = {
                PaymentType: 2, // Data.Enums.PaymentType.OnlinePayment
                Status: 1, // Data.Enums.PaymentStatusType.Success
                Token: result.paymentIntent.id,
                LogData: `3D Secure Payment succeeded: Currency: ${
                  result.paymentIntent.currency
                }, Payment Method: ${
                  result.paymentIntent.payment_method
                }, Amount: ${result.paymentIntent.amount || 0}`
              };

              that.submit(reportPayment);
            }
          });
      } else if (response.status == 200 && response.data.success == true) {
        // Show success message
        this.submit(response.data.ReportPayment);
      } else if (response.status == 401) {
        this.formErrors.push(
          "It seems your log in session has expired, please log out and back in to try again"
        );
      } else {
        this.formErrors.push(
          "An unknown error has occured processing your payment"
        );
      }
      this.$store.commit("SET_LOADING", false);
    },
    async submit(reportPayment) {
      this.$store.commit("SET_LOADING", true);

      var matchingReport = this.reports.filter(
        report => report.ReportTypeId == this.selectedReportType.ReportTypeId
      )[0];

      let data = {
        ReportTypeId:
          matchingReport !== undefined ? matchingReport.ReportTypeId : 0,
        Longitude: this.markerPosition.lng,
        Latitude: this.markerPosition.lat,
        ProjectName: this.projectName,
        ProjectCode: this.projectCode,
        ReportPayment: reportPayment,
        PurchaseOrderNumber: this.purcahseOrderNumber
      };

      let createReport = await this.$reports.createReport(data);

      //All good
      if (createReport.status === 200) {
        this.createReportSuccess = true;
        this.$store.commit("SET_LOADING", false);
        this.$router.push({ name: "report-history", query: { success: true } });
      }

      //Server generated errors
      if (createReport.status === 400) {
        this.$store.commit("SET_LOADING", false);
        if (createReport.data) {
          if (createReport.data.ModelState) {
            let serverModelErrors = Object.values(
              createReport.data.ModelState
            ).flat();
            this.formErrors = this.formErrors.concat(serverModelErrors);
          } else if (createReport.data.Message) {
            this.formErrors.push(createReport.data.Message);
          }
        }
      }

      this.$store.commit("SET_LOADING", false);
    },
    dblClick(click) {
      this.setMarkerPosition(click);
    },
    restrictMap() {
      var bounds = this.$refs.map.getBounds();

      let North = bounds.getNorthEast().lat();
      let East = bounds.getNorthEast().lng();
      let South = bounds.getSouthWest().lat();
      let West = bounds.getSouthWest().lng();

      const CONRWALL_BOUNDS = {
        north: 50.97252572979289,
        south: 49.867468905964095,
        east: -4.090335319055839,
        west: -5.702578971399589
      };
    }
  }
};
</script>
<style scoped lang="scss">
.map-container,
.map {
  min-height: calc(100vh - 103px);
  position: static;
}
.check {
  line-height: 24px;
  text-align: center;
  height: 24px;
  min-width: 24px;
  border-radius: 50%;
  border: 1px solid #adaf36;
  color: #fff;
}
.list-group-item {
  user-select: none;

  &.list-group-item__selected,
  &:hover {
    cursor: pointer;
    background-color: #adaf36;
    & > .list-group-item__content > .check {
      background-color: #87882d;
    }
    & > .list-group-item__content > .price {
      color: #ffffff !important;
    }
  }
}
.disabled {
  background-color: #dadada;
  border-color: #979797;
}
</style>
